var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lock-final-goal-name-wrapper"},[_vm._t("default"),_c('span',{staticClass:"lock-final-goal-name-wrapper__placeholder"},[_vm._v("最終目標")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }